module.exports = __webpack_public_path__ + "media/images/icons/country_flags/eh-a2b2a954b35253b4d8106f855a103b6b.svg";